<template>
  <div>
    <answer-render ref="answer" :config="config" :cvtLang="cvtLang">
      <div slot="body">
        <answer-option-list
          :config="config"
          prop="value"
          :answerValidate="answerValidate"
          :model="config"
          :cvtLang="cvtLang"
          optionKey="optionName"
          optionValueKey="id"
        ></answer-option-list>
      </div>
    </answer-render>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import answerValidate from './answerValidate'
export default {
  name: 'RadioBoxAnswer',
  props: ['config'],
  data () {
    return {
      answerValidate
    }
  },
  components: {},
  watch: {},
  computed: {
    ...mapState({
      lang: ({Question}) => Question.lang,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
      langMap: ({Question}) => Question.langMap
    })
  },
  methods: {
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    }
  },
  created () {},
  mounted () {}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/editor/RadioBox/RadioBoxAnswer.vue